import React from 'react';
import Footer from 'components/commons/Footer';
import Icon from 'components/commons/icon/Icon';
import { useRouting } from 'hooks/useRouting';
import { HeadBlock } from './components/HeadBlock';

const AnotherServiceAlignment: React.FC = props => {
  const routing = useRouting();

  const back = (): void => {
    routing.backRouting(true);
  };

  return (
    <>
      <HeadBlock />
      <header className="bg-gray-100 border-b-2 border-gray-300" id="id_header">
        <nav className="flex p-2">
          <div className="flex-1 flex justify-start">
            <button className={`flex items-center p-2 }`} onClick={back}>
              <Icon name="chevron-left" className="text-2xl text-gray-700" />
            </button>
          </div>

          <h1 className="font-bold text-center p-2">
            外部サービスとの連携について
          </h1>
          <div className="flex-1 flex justify-end"></div>
        </nav>
      </header>

      <div className="ml-2 mr-2 mt-2 p-4 bg-white">
        <div className="text-lg font-bold mb-2 text-bluegray-700">
          外部サービスとの連携について
        </div>
        <div className="text-xs mb-4 text-bluegray-500">2022/12/01</div>
        <div className="text-base text-bluegray-700">
          <div>
            MINKABU ASSET
            PLANNNER（以下、「みんかぶアセットプランナー」）は下記外部サービスと連携することで、
          </div>
          <div>
            　・MONO Account Aggregation（提供元：株式会社MONO Investment）
          </div>
          <div className="mb-8">
            お客様が各金融機関（銀行や証券会社等）に保有する金融情報（残高や保有銘柄、取引履歴等）を表示します。
          </div>

          <div className="mb-8">
            お客様は外部サービスとみんかぶアセットプランナーを連携するにあたり、お客様が外部サービス上で入力した情報および外部サービスを介して取得する金融情報（以下、本データ）について、外部サービス提供元が本データを取得および利用することについて同意するものとします。
          </div>

          <div className="mb-8">
            外部サービスはお客様の意思に基づき利用されるものであり、外部サービス提供元は外部サービス提供元が本データを適法に取得することができることを表明し保証します。
          </div>

          <div className="mb-8">
            <div>
              外部サービス提供元は、取得した本データを外部サービス提供元のプライバシーポリシー等に則り利用します。
            </div>
            <div>
              　・株式会社MONO Investment　
              <a
                className="underline"
                href="https://monoinv.com/privacypolicy/"
                target="_blank"
                rel="noopener noreferrer">
                プライバシーポリシー
              </a>
            </div>
          </div>

          <div className="mb-8">
            また、みんかぶアセットプランナーに提供された情報（外部サービスとの連携により提供された情報を含む）は当社の
            <a
              className="underline"
              href="https://minkabu.co.jp/privacy_policy"
              target="_blank"
              rel="noopener noreferrer">
              プライバシーポリシー
            </a>
            に則り利用されます。
          </div>
        </div>
        <div
          className="flex justify-center text-bluegray-500 mx-1 my-2 p-2 cursor-pointer"
          onClick={back}>
          戻る
        </div>
      </div>
      <Footer showFooterMarginTop={true} />
    </>
  );
};

export default AnotherServiceAlignment;
